import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCustomers } from './customers.asynActions'
import CustomersTable from './CustomersTable'
import getCustomersModal from '../CustomersModal'
import {
	selectSelectedCustomerModal,
	selectFilters,
	selectPreviousFilters,
} from './customers.selectors'
import CustomersFilter from './CustomersFilter'
import { isEqual } from 'lodash'
import { actions } from './customers.slice'
import PageLayout from '../../components/ui/page-layout'
import { Button } from '../../components/ui/button'

const { setPreviousFilters, resetAccount } = actions

const Customers = () => {
	const dispatch = useDispatch()
	const SelectedCustomerModal = useSelector(selectSelectedCustomerModal)
	const filters = useSelector(selectFilters)
	const previousFilters = useSelector(selectPreviousFilters)
	const isFilterChange = !isEqual(filters, previousFilters)

	// Coming back to the page with unchanged filters skips the debounced fetch below, so the table
	// would show whatever was loaded before. Refresh it in the background so billing changes show up.
	useEffect(() => {
		if (previousFilters && isEqual(filters, previousFilters)) {
			dispatch(fetchCustomers({ filters, useCaching: false, noBusySpinner: true }))
		}
		// Only on mount; filter changes are handled by the debounced effect.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		const timeOutId = setTimeout(() => {
			dispatch(setPreviousFilters(filters))
			if (isFilterChange) {
				dispatch(resetAccount())
				dispatch(fetchCustomers({ filters, useCaching: isFilterChange }))
			}
		}, 1000)
		return () => clearTimeout(timeOutId)
	}, [dispatch, filters, isFilterChange])
	
	const action = <Button>Add Account</Button>
	return (
		<PageLayout title='Accounts'>	
		
			{SelectedCustomerModal && getCustomersModal(SelectedCustomerModal)}
			<div className='flex flex-col gap-2'>
				<CustomersFilter />
				<CustomersTable />
			</div>
		</PageLayout>
	)
}

export default Customers
